import script from "./saveToDatabase.vue?vue&type=script&setup=true&lang=js"
export * from "./saveToDatabase.vue?vue&type=script&setup=true&lang=js"

import "./saveToDatabase.vue?vue&type=style&index=0&id=ce506e3c&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce506e3c"]])

export default __exports__